import { render, staticRenderFns } from "./withdrawal-add-or-update.vue?vue&type=template&id=d487865c"
import script from "./withdrawal-add-or-update.vue?vue&type=script&lang=js"
export * from "./withdrawal-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports